import Demo from './Demo';
import Initials from './Initials';

const index = {
  Demo,
  Initials,
};

export default index;
